var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7089)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.416667,
    y: 0.416667,
    width: 19.1667,
    height: 19.1667,
    rx: 9.58333,
    stroke: "white",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 6.66602L13.3327 13.3327",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 6.66602L6.66735 13.3317",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleIcon);
export default __webpack_public_path__ + "static/media/crossCircleIcon.5035fe59748e76abc530059d73728e88.svg";
export { ForwardRef as ReactComponent };